module.exports = __webpack_public_path__ + "img/freespin3.088d1ae5.png";